import React from "react";

import { Button, DialogActions } from '@mui/material';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import { ModalTitle } from './modal-title';
import { OrganisationDiagram } from './organisation-diagram';

interface UserSettingsModalProps {
  open: boolean;
  handleClose: () => void;
}

export const OrganisationDiagramModal = ({ open, handleClose }: UserSettingsModalProps) => {

  const onClose = () => {
    handleClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth="md"
    >
      <ModalTitle onClose={onClose}>Your organisation structure</ModalTitle>
      <DialogContent
        sx={{ display: 'flex', flexDirection: 'column', gap: 2, width: '100%' }}
      >
        <OrganisationDiagram />
      </DialogContent>
      <>
        <DialogActions sx={{ pb: 3, px: 3 }}>
          <Button onClick={onClose}>Close</Button>
        </DialogActions>
      </>
    </Dialog>
  );
}